// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"9e9f4ffd","902":"b1b5390e"}[chunkId] + ".chunk.js";
};